export const getRefresh = state => state.user.refresh;
export const getUser = state => state.user.user;

export default {
	getRefresh,
	getUser,
};
